/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChildrenBody } from './ChildrenBody';
import {
    ChildrenBodyFromJSON,
    ChildrenBodyFromJSONTyped,
    ChildrenBodyToJSON,
} from './ChildrenBody';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface ChildrenBodyPagination
 */
export interface ChildrenBodyPagination {
    /**
     * 
     * @type {Array<ChildrenBody>}
     * @memberof ChildrenBodyPagination
     */
    data?: Array<ChildrenBody>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof ChildrenBodyPagination
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the ChildrenBodyPagination interface.
 */
export function instanceOfChildrenBodyPagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ChildrenBodyPaginationFromJSON(json: any): ChildrenBodyPagination {
    return ChildrenBodyPaginationFromJSONTyped(json, false);
}

export function ChildrenBodyPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChildrenBodyPagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(ChildrenBodyFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function ChildrenBodyPaginationToJSON(value?: ChildrenBodyPagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(ChildrenBodyToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

